import { useLazyQuery } from "@apollo/client";
import { useContext, useEffect } from "react";

import { ConfigLabels } from "../utils/Enum.types";

import { AppContext } from "../context/context";
import
{
  GetSwConfigVariablesResult,
  GetSwConfigVariablesVar,
  SwConfigQueryType,
} from "../components/modules/asset/masters/items/configurations/queries/type";
import useUrlParams from "./useUrlParams";
import { GetSwConfigVariables } from "../components/modules/asset/masters/items/configurations/queries/queries";

export type ConfigKey = ConfigLabels;

const useSwConfigData = ( configKey: ConfigKey | ConfigKey[] ) =>
{
  const { customer_id } = useUrlParams();

  const { state } = useContext( AppContext );
  const [ GetSwVariablesData, { data, loading, error } ] = useLazyQuery<
    GetSwConfigVariablesResult,
    GetSwConfigVariablesVar
  >( GetSwConfigVariables );

  useEffect( () =>
  {
    const fetchData = async () =>
    {
      try
      {
        if ( customer_id || state.customerId )
        {
          GetSwVariablesData( {
            variables: {
              customerID: customer_id ? customer_id : state.customerId,
              input: {
                queryType: SwConfigQueryType.EDUATE_COMPLETE_CONFIG,
              },
            },
          } );
        }
      } catch ( err )
      {
        console.error( ( err as Error ).message );
      }
    };
    fetchData();
  }, [ customer_id, state.customerId, GetSwVariablesData ] );

  return { configData: { data, loading, error } };
};

export default useSwConfigData;
